import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ResourcesArr } from 'interfaces/components/resources';

export interface ChartsInfo {
  isSidebarOpen: boolean;
  selectedChartIndex: number;
  resourcesArr: ResourcesArr[];
  chartsData: { id: number; title: string }[];
}

const initialState: ChartsInfo = {
  chartsData: [],
  resourcesArr: [],
  isSidebarOpen: true,
  selectedChartIndex: 0
};

const chartsInfoSlice = createSlice({
  name: 'chartsInfo',
  initialState,
  reducers: {
    setSelectedChartIndex(state, action: PayloadAction<number>) {
      state.selectedChartIndex = action.payload;
    },
    setChartsData(state, action: PayloadAction<ChartsInfo['chartsData']>) {
      state.chartsData = action.payload;
    },
    setResourcesArr(state, action: PayloadAction<ResourcesArr[]>) {
      state.resourcesArr = action.payload;
    },
    toggleSidebarOpen(state) {
      state.isSidebarOpen = !state.isSidebarOpen;
    }
  }
});

export const {
  setSelectedChartIndex,
  setChartsData,
  setResourcesArr,
  toggleSidebarOpen
} = chartsInfoSlice.actions;

export default chartsInfoSlice.reducer;
